export const scroll = {
  container: ".data-scroll-container",
   options: {
    smooth: true,
    multiplier:1.15, 
    getDirection: true,
    getSpeed:true,
    lerp:.1,
    smartphone: {
      smooth: false
    } 
  },
}